import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Trans, useTranslation } from 'react-i18next';

import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import AgeInput from '../AgeInput/AgeInput';
import SwiperButton from '../SwiperButton/SwiperButton';

import "swiper/css";
import "swiper/css/navigation";

const PlayerMenuPanel = (props) => {
    const { t } = useTranslation(["common", "glossary", "Index/PlayerMenuPanel"]);

    const [slideIndex, setSlideIndex] = useState(0);

    const handleGenderSelect = (event) => { props.updatePlayerData({ gender: event.target.value }); };
    const handleChildAgeSelect = (value) => props.updatePlayerData({ childAge: value });
    const handleAdultAgeSpanSelect = (event) => props.updatePlayerData({
        adultAgeSpan: event.target.value == "no-selection" ? null : event.target.value
    });
    const handleLevelOfEducationSelect = (event) => props.updatePlayerData({
        levelOfEducation: event.target.value == "no-selection" ? null : event.target.value
    });
    const handleFirstTimeSelect = (event) => { props.updatePlayerData({ firstTime: event.target.value }); };
    const handleDifficultySelect = (event) => { props.updatePlayerData({ difficulty: event.target.value }); };

    const currentSlideInputValue = props.data[Object.keys(props.data)[slideIndex]];
    const playerReady = Object.values(props.data).every(value => value != null);
    
    return <Swiper
        onRealIndexChange = { (swiper) => setSlideIndex(swiper.activeIndex) }
        modules = {[ Navigation ]}
        noSwiping
        noSwipingClass = 'swiper'
    >
        <div className = 'd-flex justify-content-evenly align-items-top top-0 my-3'>
            <SwiperButton
                type = "back"
                disabled = { slideIndex <= 0 }
            />
            <button
                type = "button"
                className = { `btn btn-lg fs-3 btn-light ${!playerReady ? "disabled opacity-0" : ""}` }
                onClick = { props.handleTutorialStart }
            >
                { t("Index/PlayerMenuPanel:startGameButton") }
            </button>
            <SwiperButton
                type = "next"
                disabled = {
                    currentSlideInputValue == null ||
                    slideIndex >= (Object.keys(props.data).length - 1)
                }
            />
        </div>
        {
            props.isAdult ? <>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:genderMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "man"
                            value = "man"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "man">{ t("glossary:man") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "woman"
                            value = "woman"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "woman">{ t("glossary:woman") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "transgender"
                            value = "transgender"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "transgender">{ t("glossary:transgender") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "non-binary"
                            value = "non_binary"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "non-binary">{ t("glossary:nonBinary") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "other"
                            value = "other"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "other">{ t("glossary:other") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "no-answer"
                            value = "no_answer"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "no-answer">{ t("glossary:noAnswer") }</label>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:ageSpanMenu.title") }</div>
                    <div className = 'overflow-hidden'>
                        <select
                            className = "form-select w-auto mx-auto fs-3"
                            onChange = { handleAdultAgeSpanSelect }
                            defaultValue = { null }
                        >
                            <option value = "no-selection">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.noSelection") }</option>
                            <option value = "18-25">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.18_25") }</option>
                            <option value = "26-35">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.26_35") }</option>
                            <option value = "36-45">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.36_45") }</option>
                            <option value = "46-55">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.46_55") }</option>
                            <option value = "56-65">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.56_65") }</option>
                            <option value = "66-75">{ t("Index/PlayerMenuPanel:ageSpanMenu.adult.66_75") }</option>
                            <option value = "older">{ t("glossary:older") }</option>
                        </select>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>
                        { t("Index/PlayerMenuPanel:levelOfEducationMenu.title") }
                    </div>
                    <div className = 'overflow-hidden'>
                        
                        <select
                            className = "form-select w-auto mx-auto fs-3"
                            onChange = { handleLevelOfEducationSelect }
                            defaultValue = { null }
                        >
                            <Trans
                                t = { t }
                                i18nKey = { "Index/PlayerMenuPanel:levelOfEducationMenu.select" }
                                values = {{
                                    noSelection: t("Index/PlayerMenuPanel:levelOfEducationMenu.noSelection"),
                                    noDiploma: t("Index/PlayerMenuPanel:levelOfEducationMenu.noDiploma"),
                                    middleSchoolDiploma: t("Index/PlayerMenuPanel:levelOfEducationMenu.middleSchoolDiploma"),
                                    technicalDiploma: t("Index/PlayerMenuPanel:levelOfEducationMenu.technicalDiploma"),
                                    highSchoolDiploma: t("Index/PlayerMenuPanel:levelOfEducationMenu.highSchoolDiploma"),
                                    undergraduate: t("Index/PlayerMenuPanel:levelOfEducationMenu.undergraduate"),
                                    superiorTechnicalDiploma: t("Index/PlayerMenuPanel:levelOfEducationMenu.superiorTechnicalDiploma"),
                                    licenseOrBachelor: t("Index/PlayerMenuPanel:levelOfEducationMenu.licenseOrBachelor"),
                                    masterOrEquivalent: t("Index/PlayerMenuPanel:levelOfEducationMenu.masterOrEquivalent"),
                                    phd: t("Index/PlayerMenuPanel:levelOfEducationMenu.phd"),
                                    other: t("glossary:other"),
                                    noAnswer: t("Index/PlayerMenuPanel:levelOfEducationMenu.noAnswer"),
                                }}
                                components = {{
                                    noSelection: <option value = "no-selection" />,
                                    noDiploma: <option value = "no_diplomas" />,
                                    middleSchoolDiploma: <option value = "middle_school_diploma" />,
                                    technicalDiploma: <option value = "technical_diploma" />,
                                    highSchoolDiploma: <option value = "high_school_diploma" />,
                                    undergraduate: <option value = "undergraduate" />,
                                    superiorTechnicalDiploma: <option value = "superior_technical_diploma" />,
                                    licenseOrBachelor: <option value = "license_or_bachelor" />,
                                    masterOrEquivalent: <option value = "master" />,
                                    phd: <option value = "phd" />,
                                    other: <option value = "other" />,
                                    noAnswer: <option value = "no_answer" />,
                                }}
                            />
                        </select>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:firstTimeMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "never"
                            value = "never"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "never">{ t("glossary:never") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "once"
                            value = "once"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "once">{ t("glossary:once") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "more-than-once"
                            value = "more_than_once"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "more-than-once">{ t("glossary:moreThanOnce") }</label>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:difficultyMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "difficulty"
                            id = "easy"
                            value = "easy"
                            autoComplete = "off"
                            onClick = { handleDifficultySelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "easy">{ t("glossary:easy") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "difficulty"
                            id = "hard"
                            value = "hard"
                            autoComplete = "off"
                            onClick = { handleDifficultySelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "hard">{ t("glossary:hard") }</label>
                    </div>
                </SwiperSlide>
            </> : <>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:genderMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "boy"
                            value = "boy"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "boy">{ t("glossary:boy") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "girl"
                            value = "girl"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "girl">{ t("glossary:girl") }</label>
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "gender"
                            id = "no-answer"
                            value = "no_answer"
                            autoComplete = "off"
                            onClick = { handleGenderSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "no-answer">{ t("glossary:noAnswer") }</label>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:ageSpanMenu.title") }</div>
                    <AgeInput
                        min = { 5 }
                        max = { 18 }
                        default = { 5 }
                        updateValue = { handleChildAgeSelect }
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:firstTimeMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "never"
                            value = "never"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "never">{ t("glossary:never") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "once"
                            value = "once"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "once">{ t("glossary:once") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "first-time"
                            id = "more-than-once"
                            value = "more_than_once"
                            autoComplete = "off"
                            onClick = { handleFirstTimeSelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "more-than-once">{ t("glossary:moreThanOnce") }</label>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className = 'display-3 mb-5'>{ t("Index/PlayerMenuPanel:difficultyMenu.title") }</div>
                    <div className = "btn-group btn-group-lg flex-wrap text-nowrap mx-1" role = "group">
                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "difficulty"
                            id = "easy"
                            value = "easy"
                            autoComplete = "off"
                            onClick = { handleDifficultySelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "easy">{ t("glossary:easy") }</label>

                        <input
                            type = "radio"
                            className = "btn-check"
                            name = "difficulty"
                            id = "hard"
                            value = "hard"
                            autoComplete = "off"
                            onClick = { handleDifficultySelect }
                        />
                        <label className = "btn btn-outline-light fs-2" htmlFor = "hard">{ t("glossary:hard") }</label>
                    </div>
                </SwiperSlide>
            </>
        }
    </Swiper>;
};

PlayerMenuPanel.propTypes = {
    data: PropTypes.object,
    isAdult: PropTypes.bool,
    updatePlayerData: PropTypes.func,
    handleTutorialStart: PropTypes.func,
};

export default PlayerMenuPanel;